<template>
    <aside class="sidebar">
        <lot-search
            size="small"
            :isReduced="true"
            class="hidden-below-md"
        ></lot-search>

        <div id="auex-live-ticker-wrapper">
            <sidebar-box-auex-ticker
                v-for="liveBiddingTicker in auexLiveTickerAuctions"
                :key="liveBiddingTicker.auctionId"
                :baseUrl="'https://' + liveBiddingTicker.hostname"
                :auctionId="liveBiddingTicker.auctionId"
            />
        </div>

        <div id="bidinside-live-ticket-wrapper">
            <sidebar-box-bid-inside-ticker
                v-for="liveBiddingTicker in bidInsideLiveTickerAuctions"
                :key="liveBiddingTicker.auctionid"
                :tickerUrl="liveBiddingTicker.ticker_url"
                :auctionId="liveBiddingTicker.auctionid"
            />
        </div>

        <sidebar-box
            v-if="
                flexibleTeaserBoxes['1-flexible-box'] &&
                flexibleTeaserBoxes['1-flexible-box'].boxVisible == 1
            "
            :headline="flexibleTeaserBoxes['1-flexible-box'].headline"
        >
            <div v-html="flexibleTeaserBoxes['1-flexible-box'].content"></div>
        </sidebar-box>
        <sidebar-box
            v-if="
                flexibleTeaserBoxes['2-flexible-box'] &&
                flexibleTeaserBoxes['2-flexible-box'].boxVisible == 1
            "
            :headline="flexibleTeaserBoxes['2-flexible-box'].headline"
        >
            <div v-html="flexibleTeaserBoxes['2-flexible-box'].content"></div>
        </sidebar-box>

        <!-- currently not in use
        <sidebar-box class="livebidding-box" :headline="$t('Sincona Live-Ticker')">
            <iframe class="livebidding-iframe" src="https://auexliveticker.inova.de/SINCONA.aspx" />
        </sidebar-box>
        -->

        <sidebar-box-highlight-special />
        <sidebar-box-highlight />

        <!-- currently not in use
        <sidebar-box-newsletter />
        -->
        <sidebar-box
            v-if="
                flexibleTeaserBoxes['3-flexible-box'] &&
                flexibleTeaserBoxes['3-flexible-box'].boxVisible == 1
            "
            :headline="flexibleTeaserBoxes['3-flexible-box'].headline"
        >
            <div v-html="flexibleTeaserBoxes['3-flexible-box'].content"></div>
        </sidebar-box>
        <sidebar-box
            v-if="
                flexibleTeaserBoxes['4-flexible-box'] &&
                flexibleTeaserBoxes['4-flexible-box'].boxVisible == 1
            "
            :headline="flexibleTeaserBoxes['4-flexible-box'].headline"
        >
            <div v-html="flexibleTeaserBoxes['4-flexible-box'].content"></div>
        </sidebar-box>

        <coin-collector></coin-collector>

        <sidebar-box-best-coins />

        <div
            v-if="getAds['Sidebar-3'] || getAds['Sidebar-4']"
            class="sidebar-box-group"
        >
            <div class="sidebar-box-slots">
                <ad-banner
                    v-if="getAds['Sidebar-3']"
                    :ad="getAds['Sidebar-3']"
                />
            </div>
            <div class="sidebar-box-slots">
                <ad-banner
                    v-if="getAds['Sidebar-4']"
                    :ad="getAds['Sidebar-4']"
                />
            </div>
        </div>

        <div
            v-if="getAds['Sidebar-1'] || getAds['Sidebar-2']"
            class="sidebar-box-group"
        >
            <div class="sidebar-box-slots">
                <ad-banner
                    v-if="getAds['Sidebar-1']"
                    :ad="getAds['Sidebar-1']"
                />
            </div>
            <div class="sidebar-box-slots">
                <ad-banner
                    v-if="getAds['Sidebar-2']"
                    :ad="getAds['Sidebar-2']"
                />
            </div>
        </div>

        <sidebar-box :headline="$t('news_numismatic')" v-if="!newsHidden">
            <p>
                {{ $t('news_numismatic_world') }}
            </p>
            <p
                class="powered-by-coinsweekly"
                v-html="$t('powered_by_coinsweekly')"
            ></p>
            <news-list :news="news"></news-list>
        </sidebar-box>

        <sidebar-box :headline="$t('history_week')" v-if="!twihHidden">
            <twih-list :twih="twih"></twih-list>
        </sidebar-box>
    </aside>
</template>

<script>
import SidebarBox from '../components/SidebarBox';
import NewsList from '../components/NewsList';
import TwihList from '../components/TwihList';
import LotSearch from '../components/LotSearch.vue';
import CoinCollector from '../components/CoinCollector.vue';
import SidebarBoxAuexTicker from '../components/SidebarBoxAuexTicker.vue';
import SidebarBoxBidInsideTicker from '../components/SidebarBoxBidInsideTicker.vue';
import SidebarBoxBestCoins from '../components/SidebarBoxBestCoins.vue';
import SidebarBoxHighlight from '../components/SidebarBoxHighlight.vue';
import SidebarBoxHighlightSpecial from '../components/SidebarBoxHighlightSpecial.vue';
import SidebarBoxNewsletter from '../components/SidebarBoxNewsletter.vue';
import AdBanner from '../components/AdBanner';

import { mapGetters } from 'vuex';
import {
    getFlexibleTeaserBoxes,
    getAuexRunningAuctions,
    getBidInsideRunningAuctions,
    getNewsList,
    getThisWeekInHistory,
} from '../lib/apis';

export default {
    name: 'HomeSidebar',
    components: {
        SidebarBox,
        NewsList,
        TwihList,
        LotSearch,
        CoinCollector,
        SidebarBoxAuexTicker,
        SidebarBoxBidInsideTicker,
        SidebarBoxBestCoins,
        SidebarBoxHighlight,
        SidebarBoxHighlightSpecial,
        SidebarBoxNewsletter,
        AdBanner,
    },
    data: function () {
        return {
            news: [],
            newsHidden: false,
            twih: [],
            twihHidden: false,

            buyNowItems: [],
            flexibleTeaserBoxes: [],
            auexLiveTickerAuctions: [],
            bidInsideLiveTickerAuctions: [],
        };
    },
    computed: {
        ...mapGetters({ getAds: 'ads/getAds' }),
    },
    mounted: function () {
        this.fetchFlexibleTeaserBoxes();
        this.fetchAuexRunningAuctions();
        this.fetchBidInsideRunningAuctions();
        this.fetchNews();
        this.fetchTwih();
    },
    methods: {
        fetchFlexibleTeaserBoxes() {
            getFlexibleTeaserBoxes(this.$route.params.lang)
                .then((response) => {
                    this.flexibleTeaserBoxes = response.data;
                })
                .catch((e) => {
                    this.genericApiErrorHandling(e);
                });
        },
        fetchAuexRunningAuctions() {
            getAuexRunningAuctions()
                .then((response) => {
                    this.auexLiveTickerAuctions = response.data;
                })
                .catch((e) => {
                    this.genericApiErrorHandling(e);
                });
        },
        fetchBidInsideRunningAuctions() {
            getBidInsideRunningAuctions()
                .then((response) => {
                    this.bidInsideLiveTickerAuctions = response.data;
                })
                .catch((e) => {
                    this.genericApiErrorHandling(e);
                });
        },
        fetchNews() {
            getNewsList(this.$route.params.lang)
                .then((news) => {
                    if (news.data.length === 0) {
                        this.newsHidden = true;
                    } else {
                        if (typeof news.data === 'string') {
                            this.newsHidden = true;
                        } else {
                            this.newsHidden = false;
                            this.news = news.data;
                        }
                    }
                })
                .catch((e) => {
                    this.genericApiErrorHandling(e);
                });
        },
        fetchTwih() {
            getThisWeekInHistory(this.$route.params.lang)
                .then((twih) => {
                    if (twih.data && typeof twih.data === 'object' && Object.keys(twih.data).length > 0) {
                        this.twihHidden = false;
                        this.twih = Object.values(twih.data);
                    } else {
                        this.twihHidden = true;
                    }
                })
                .catch((e) => {
                    this.genericApiErrorHandling(e);
                });
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.livebidding-iframe {
    width: 100%;
    height: 250px;
    border: none;
    margin-top: 15px;
}
</style>

<style lang="scss" scoped>
#auex-live-ticker-wrapper,
#bidinside-live-ticket-wrapper {
    display: flex;
    flex-direction: column;
}
.powered-by-coinsweekly {
    margin-top: 0;
}

.sidebar-box-group {
    display: flex;
    justify-content: space-between;
}

.sidebar-box-slots {
    background: $grey-bg-light;
    padding: $pad-md;
    margin-bottom: $mar-lg;
    line-height: 0;
    width: calc(50% - #{$pad-md});

    &:first-child {
        margin-right: $pad-md;
    }
    &:last-child {
        margin-left: $pad-md;
    }
}
</style>
